<h1 mat-dialog-title>{{ data.title | translate }}</h1>
<div mat-dialog-content>
	<p>{{ data.content | translate }}</p>
	<p *ngIf="data.content2 != undefined">{{ data.content2 | translate }}</p>
</div>
<div class="buttons-container"
	 mat-dialog-actions
	 [class.justify-content-end]="!!!data.cancelButtonLabel">
	<button *ngIf="!!data.cancelButtonLabel"
			class="dialog-button"
			mat-raised-button
			[color]="data.cancelButtonColor ?? 'primary'"
			[mat-dialog-close]="'no'"><span
		[class.text-white]="data.cancelButtonColor != 'basic' && data.cancelButtonColor != 'accent'">{{ data.cancelButtonLabel }}</span>
	</button>
	<button *ngIf="!!data.allButtonLabel"
			class="dialog-button"
			mat-raised-button
			[color]="data.allButtonLabel ?? 'primary'"
			[mat-dialog-close]="'all'"><span
		[class.text-white]="data.allButtonColor != 'basic' && data.allButtonColor != 'accent'">{{ data.allButtonLabel }}</span>
	</button>
	<button *ngIf="!!data.confirmButtonLabel"
			class="dialog-button"
			mat-raised-button
			[color]="data.confirmButtonColor ?? 'primary'"
			[mat-dialog-close]="'one'"><span
		[class.text-white]="data.confirmButtonColor != 'basic' && data.confirmButtonColor != 'accent'">{{ data.confirmButtonLabel }}</span>
	</button>
</div>
